/*    
<summary>
  This functional component shows the fota jet release details.
  Developer:Deepak Paliwal, Created Date: 07-Sept-2025
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/StoreProvider";
import { IFotaTenantReleaseList } from "../../../models/response/IFotaResponse";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import FotaStatusEnum from "../../../constants/fota-status-enum";

interface IProps {
    selectedData: IFotaTenantReleaseList;
}

const FotaModemDetails = (props: IProps) => {
    const { fotaTntReleaseStore, tenantStore } = useStore();
    const {
        GetFotaModemScheduleByIdService,
        getFotaModemScheduleInfo,
        fotaModemScheduleDetailState,
    } = fotaTntReleaseStore;
    const { selectedTenantId } = tenantStore;


    const callGetFotaById = () => {
        GetFotaModemScheduleByIdService(props?.selectedData.Id);
    };

    useEffect(() => {
        if (props?.selectedData.Id > 0) {
            callGetFotaById();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.selectedData.Id]);

    return (
        <React.Fragment>
            {fotaModemScheduleDetailState.inProgress && (
                <FormLoader loading={fotaModemScheduleDetailState.inProgress} />
            )}
            {getFotaModemScheduleInfo && (
                <div className="p-3">
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                                <FormattedMessage id="fota_config_name" />:{" "}
                            </label>
                        </div>
                        <div className="col-6">
                            <p className="mw-100">
                                <span>{getFotaModemScheduleInfo.ConfigName}</span>
                            </p>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                                <FormattedMessage id="config_version" />:{" "}
                            </label>
                        </div>
                        <div className="col-6">
                            <p className="mw-100">
                                <span>{getFotaModemScheduleInfo.ConfigVersion}</span>
                            </p>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                                <FormattedMessage id="status" />:{" "}
                            </label>
                        </div>
                        <div className="col-6">
                            <p className="mw-100">
                                <span>{getFotaModemScheduleInfo.IsScheduleAborted === true ? <FormattedMessage id="aborted" /> : <FormattedMessage id={FotaStatusEnum[getFotaModemScheduleInfo.Status]} />}</span>
                            </p>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                                <FormattedMessage id="progress" />:{" "}
                            </label>
                        </div>
                        <div className="col-6">
                            <p className="mw-100">
                                <span>{getFotaModemScheduleInfo.Progress} %</span>
                            </p>
                        </div>
                    </div>
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                                <FormattedMessage id="schedule_duration_limit" />:{" "}
                            </label>
                        </div>
                        <div className="col-6">
                            <p className="mw-100">
                                <span>{getFotaModemScheduleInfo.ScheduleDurationDay}</span>
                            </p>
                        </div>
                    </div>
                    {getFotaModemScheduleInfo.Description && (
                        <div className="row pt-2">
                            <div className="col-6">
                                <label className="text-muted bold">
                                    <FormattedMessage id={"desc"} />:{" "}
                                </label>
                            </div>
                            <div className="col-6">
                                <p className="mw-100">
                                    <span>{getFotaModemScheduleInfo.Description}</span>
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </React.Fragment>
    );
};

export default observer(FotaModemDetails);
